/** Keep authenticated requests on the host that owns the session cookie. */
export function apiUrl(value: string, origin = import.meta.env.VITE_API_ORIGIN || ""): string {
	if (!origin) return value;
	let path = value;
	if (!value.startsWith("/") || value.startsWith("//")) {
		if (typeof window === "undefined") return value;
		try {
			const url = new URL(value, window.location.origin);
			if (url.origin !== window.location.origin && url.origin !== origin.replace(/\/$/, "")) return value;
			path = `${url.pathname}${url.search}${url.hash}`;
		} catch {
			return value;
		}
	}
	const base = origin.replace(/\/$/, "");
	if (path.startsWith("/api/v1/") || path.startsWith("/auth/")) return `${base}${path}`;
	if (path.startsWith("/api/")) return `${base}/api/v1/agent/${path.slice(5)}`;
	return value;
}

/** Raw streams and file reads need the same routing and cookie as JSON calls. */
export function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
	const value = typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
	const target = apiUrl(value);
	const origin = (import.meta.env.VITE_API_ORIGIN || "").replace(/\/$/, "");
	const internal =
		target !== value ||
		/^(\/api\/|\/auth\/)/.test(value) ||
		(Boolean(origin) && (target.startsWith(`${origin}/api/`) || target.startsWith(`${origin}/auth/`)));
	const request =
		typeof input === "string" || input instanceof URL ? target : target === value ? input : new Request(target, input);
	return fetch(request, internal ? { ...init, credentials: "include" } : init);
}
